import { createContext, useContext } from 'react';

const SidebarContext = createContext({
  openSidebar: () => {},
  closeSidebar: () => {},
});

export function useSidebar() {
  return useContext(SidebarContext);
}

export default SidebarContext;
